import React from "react";

const CommentIcon = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4609 0.5H3.46094C2.05469 0.5 0.960938 1.63281 0.960938 3V14.2109C0.960938 15.5781 2.05469 16.6719 3.46094 16.6719H7.21094V19.9531C7.21094 20.3438 7.64062 20.5391 7.95312 20.3047L12.8359 16.6719H18.4609C19.8281 16.6719 20.9609 15.5391 20.9609 14.2109V3C20.9609 1.63281 19.8672 0.5 18.4609 0.5ZM19.75 14.25C19.75 14.9531 19.1641 15.5 18.5 15.5H12.8359C12.5625 15.5 12.3281 15.6172 12.0938 15.7734L8.5 18.4688V16.125C8.5 15.8125 8.1875 15.5 7.875 15.5H3.5C2.79688 15.5 2.25 14.9531 2.25 14.25V3C2.25 2.33594 2.79688 1.75 3.5 1.75H18.5C19.1641 1.75 19.75 2.33594 19.75 3V14.25Z"
        fill="#0F1734"
      />
    </svg>
  );
};

export default CommentIcon;
